import React, { ChangeEvent } from "react";
import SearchInput from "../../../../../ui/widgets/search-input";
import { AutocompleteProps } from "./types";

import "../styles.scss";
import Autocomplete from "../index";

export default function CompanyAutocomplete<T>({
  label,
  id,
  doSearch,
  onSearchInputChange,
  onSelect,
  itemToSuggestion,
  selected,
  error,
  helperText,
  onBlur,
}: AutocompleteProps<T>): React.JSX.Element {
  const [items, setItems] = React.useState<T[]>([]);
  const [itemsMap, setItemsMap] = React.useState<{ [key: string]: T }>({});

  const searchCallback = async (searchTerm: string): Promise<void> => {
    const searchResults = await doSearch(searchTerm);
    const searchResultsMap = searchResults
      ? searchResults.reduce(
          (acc, obj) => ({ ...acc, ...{ [itemToSuggestion(obj)]: obj } }),
          {},
        )
      : {};
    setItems(searchResults);
    setItemsMap(searchResultsMap);
  };

  return (
    <Autocomplete
      key={id}
      id={id}
      dropdownItems={items}
      initialSelectedItem={itemToSuggestion(selected)}
      itemToSuggestion={itemToSuggestion}
      onChange={(selectedSuggestion: string): void =>
        onSelect(itemsMap[selectedSuggestion])
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      renderInput={(downshiftProps: any): React.JSX.Element => {
        const { ref, inputValue, getInputProps, clearSelection } =
          downshiftProps;
        return (
          <SearchInput
            label={label}
            value={inputValue}
            InputProps={{
              inputRef: ref,
              ...getInputProps({
                onChange: (event: ChangeEvent<HTMLInputElement>) => {
                  if (event.target.value === "") {
                    clearSelection();
                    return;
                  }
                  searchCallback(event.target.value);
                  if (typeof onSearchInputChange === "function") {
                    onSearchInputChange(event);
                  }
                },
                onBlur,
              }),
              id,
              name: id,
            }}
            error={error}
            helperText={helperText}
          />
        );
      }}
    />
  );
}
